import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=80dfb3b4&scoped=true&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=ts&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingIndicator.vue?vue&type=style&index=0&id=80dfb3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80dfb3b4",
  null
  
)

export default component.exports